// @flow
import { useCallback, useState, useEffect } from 'react';
import is from 'ramda/es/is';
import { useTranslation } from 'react-i18next';

import { api } from 'app/api';
import { GET_CAFETERIA_CUSTOMER_MENU_COMPLEXES_FREE, type ComplexesFreeParams } from 'app/common/api/requests/cafeteria/customer/menu/complexes/free';

/**
 *  Запрос данных по бесплатным комплектам
 */

export default function useComplexesFree(params: ComplexesFreeParams) {
  const { t } = useTranslation('cafeteria');
  const [data, setData] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleRequestData = useCallback(async () => {
    setLoading(true);
    const complexesFreeRes = await api.request(GET_CAFETERIA_CUSTOMER_MENU_COMPLEXES_FREE, {
      error: t('menu_kits_fetch_free_error', 'Не удалось получить данные по бесплатным комплектам'),
      params,
    });
    setLoading(false);

    if (is(Boolean, complexesFreeRes)) {
      setData(complexesFreeRes || false);
      return true;
    }

    return false;
  }, [params, t]);


  useEffect(() => {
    handleRequestData();
  }, [handleRequestData]);


  return [data, loading];
}
